import { themeStyle } from '@repo/ui/theming';

export const suggestionsTheme = {
  width: '207px',
  height: '50px',

  colorSuggestion: themeStyle.varInkMain,
  suggestionBackground: themeStyle.varInkBase,

  separator: `1px solid ${themeStyle.varInkSuperLight}`,
};
